export const paths = {
  home: '/',
  dashboard: '/dashboard',
  commission: '/commission',
  auth: {
    login: '/auth/login',
    workspace: '/auth/workspace',
  },
  pos: {
    root: '/pos',
    calendar: '/pos/calendar',
    clients: '/pos/clients',
    catalog: '/pos/catalog',
    team: '/pos/team',
    reports: '/pos/reports',
    settings: '/pos/settings',
    settingsBranches: '/pos/settings/branches',
    settingsCalendar: '/pos/settings/calendar',
    settingsPaymentMethods: '/pos/settings/payment_method',
    settingsStore: '/pos/settings/store',
    settingsPermissions: '/pos/settings/permissions',
  },
  sales: {
    root: '/sales',
    tips: '/sales/tips',
    dailysales: '/sales/dailysales',
    sales: '/sales/sales',
    detailedSales: '/sales/detailed-sales',
    payments: '/sales/payments',
    credit: '/sales/credit',
    memberships: '/sales/memberships',
    appointments: '/sales/appointments',
    vouchers: '/sales/vouchers',
    products: '/sales/products',
  },
  locations: {
    select: '/locations',
  },
  admin: {
    root: '/admin',
    login: '/admin/login',
  },
  website: '/website',
} as const;
